<div class="pt-5 text-center" id="PageNot">
  <img src="../../assets/logo-veneta.jpg" class="w-25 pb-4" alt="">
  <label class="">ERROR 404</label>
      <p class="pb-3">No hemos podido encontrar lo que buscas</p>
  <button type="button" class="btn btn-primary" routerLink="/">Ir al inicio</button>
</div>

